const ids = ['q1','q2','q3','q4','q5'];

function checkReady() {
  const allAnswered = ids.every(id => document.getElementById(id).value !== '');
  document.getElementById('submitBtn').disabled = !allAnswered;
}

function showResult() {
  const total = ids.reduce((sum, id) => sum + parseInt(document.getElementById(id).value), 0);
  const pct = Math.round((total / 10) * 100);

  const top = document.getElementById('result-top');
  const status = document.getElementById('result-status');
  const title = document.getElementById('result-title');
  const body = document.getElementById('result-body');
  const fill = document.getElementById('score-fill');
  const num = document.getElementById('score-num');

  top.className = 'result-top';

  if (total >= 8) {
    status.textContent = 'Ready';
    title.textContent = 'Your store has strong app potential.';
    body.textContent = 'Your mobile traffic, repeat customer rate, and competitive signals all point in the right direction. The next step is choosing the right approach — wrapper, app builder, or custom build — based on your budget and feature needs. Read on to compare them.';
  } else if (total >= 5) {
    top.classList.add('orange');
    status.textContent = 'Not Quite Yet';
    title.textContent = 'You\'re close, but a few signals need strengthening.';
    body.textContent = 'You have a foundation, but building an app now may underdeliver. Focus on improving your mobile site performance, growing your repeat customer rate, or nailing down your app\'s download hook first. Revisit in 3–6 months.';
  } else {
    top.classList.add('red');
    status.textContent = 'Too Early';
    title.textContent = 'An app isn\'t the right move right now.';
    body.textContent = 'Your store needs a stronger mobile foundation before an app makes sense. Prioritize mobile site speed, checkout optimization, and customer retention first. An app built on a weak mobile base won\'t fix the underlying issues — it will package them.';
  }

  fill.style.width = pct + '%';
  num.textContent = `${total} / 10`;

  const resultEl = document.getElementById('result');
  resultEl.style.display = 'block';
  resultEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
}

function resetQuiz() {
  ids.forEach(id => document.getElementById(id).value = '');
  document.getElementById('result').style.display = 'none';
  document.getElementById('submitBtn').disabled = true;
}
